export default "__VITE_ASSET__DvZ44cvI__"